// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_8w-0";